"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PindropProvider = void 0;

var _assert = require("../../utils/assert");

var _listPinsResponse = require("./response-parsers/list-pins-response");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var PindropProvider =
/*#__PURE__*/
function () {
  function PindropProvider(client) {
    _classCallCheck(this, PindropProvider);

    _assert.assert.isRequired({
      client: client
    }, 'PindropProvider::constructor');

    this._client = client;
  }

  _createClass(PindropProvider, [{
    key: "list",
    value: function list(source, ids) {
      _assert.assert.isRequired({
        source: source,
        ids: ids
      }, 'PindropProvider::list');

      _assert.assert.isNotEmptyArray({
        ids: ids
      }, 'PindropProvider::list');

      return this._client.request({
        methodName: 'GetPinDrops',
        data: {
          TableName: source,
          Ids: {
            Id: ids
          }
        },
        parseResponseDelegate: _listPinsResponse.createListPinsResponse
      });
    }
  }]);

  return PindropProvider;
}();

exports.PindropProvider = PindropProvider;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/annotations/PindropProvider.js
// module id = 236
// module chunks = 0